import { NotificationSettings } from './NotificationSettings';
export default NotificationSettings;